const reasonApiErrorMappings = {
  reason: {
    'value is not unique': 'Sudah terdaftar di sistem.'
  }
}

export default reasonApiErrorMappings